import React, { createContext, useState, useContext } from 'react'
import { useSession } from 'src/sdk/session'

interface ProductViewContextType {
  isUpdatedSlas: boolean
  filteredSlas: ShippingSimulation[]
  postalCodeSlas: string | null
  slasReady: boolean
  skuIdOfSlas: string | null
  setFilteredSlas: (filteredSlas: ShippingSimulation[]) => void
  setPostalCodeSlas: (postalCodeSlas: string | null) => void
  setSlasReady: (ready: boolean) => void
  setIsUpdatedSlas: (isUpdatedSlas: boolean) => void
  setSkuIdOfSlas: (skuIdOfSlas: string | null) => void
}

const ProductViewContext = createContext<ProductViewContextType | undefined>(undefined)

export const ProductViewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { postalCode } = useSession()
  const [filteredSlas, setFilteredSlas] = useState<ShippingSimulation[]>([])
  const [postalCodeSlas, setPostalCodeSlas] = useState<string | null>(postalCode ?? '')
  const [slasReady, setSlasReady] = useState<boolean>(false)
  const [isUpdatedSlas, setIsUpdatedSlas] = useState<boolean>(false)
  const [skuIdOfSlas, setSkuIdOfSlas] = useState<string | null>(null)

  return (
    <ProductViewContext.Provider
      value={{
        filteredSlas,
        postalCodeSlas,
        slasReady,
        isUpdatedSlas,
        skuIdOfSlas,
        setFilteredSlas,
        setPostalCodeSlas,
        setSlasReady,
        setIsUpdatedSlas,
        setSkuIdOfSlas
      }}
    >
      {children}
    </ProductViewContext.Provider>
  )
}

export const useProductViewContext = (): ProductViewContextType => {
  const context = useContext(ProductViewContext)

  if (!context) {
    throw new Error('useProductViewContext must be used within a ProductViewProvider')
  }

  return context
}
